module.exports = __webpack_public_path__ + "img/发展历程.f4128a0f.png";